import * as React from "react";
import Header from "./Header";
import Button from "./Button";
import MessengerFlexContainer from "./MessengerFlexContainer";

interface CallWaitingProps {
  waitingText: string;
  isPopout: boolean;
  onClose: () => void;
  onCollapse: () => void;
  onPopout: () => void;
  onVisitorEndCall: () => void;
}

class CallWaiting extends React.Component<CallWaitingProps, {}> {
  render() {
    return (
      <MessengerFlexContainer>
        <Header
          isPopout={this.props.isPopout}
          onClose={this.props.onClose}
          onCollapse={this.props.onCollapse}
          onPopout={this.props.onPopout}
        />
        <div className="velaro-queue-container velaro-scroll">
          <div className="velaro-call-waiting-content">
            <p>{this.props.waitingText}</p>
            <Button variant="primary" onClick={this.props.onVisitorEndCall}>
              End Call
            </Button>
          </div>
        </div>
      </MessengerFlexContainer>
    );
  }
}

export default CallWaiting;
